const dataPrecise = (state = [], action) => {
  switch(action.type) {
    case 'UPDATE_DATA_PRECISE':
      // console.log(action.dataPrecise)
      return action.graphPreciseData
    default:
      return state;
  }
}

export default dataPrecise;



// WEBPACK FOOTER //
// ./src/reducers/updateDataPrecise.js